import React, { useEffect, useState } from 'react'
import { getDateNow , convertDateToString , getDateNow2 } from '../utils'

export const ContextRollCall = React.createContext<any>({})


export default function ContextRollCallModels(props: any) {
    const [jsonParmsRollCall, setJsonParmsRollCall] = useState<any>({ 'from': getDateNow2(), 'to': getDateNow2() , 'page':1 , 'user':[] })
    const [activeFilterRollCall, setActiveFilterRollCall] = useState<any>({
        'activePeriod': -1 ,
        'displayDelay':true ,
        'displayOvertime':true ,
        'displayWork':true ,
        'location':-1 ,
        'user':[],
        'startCalender':getDateNow2(),
        'endCalender':getDateNow2(),
    })




    return (
        <ContextRollCall.Provider value={{
            activeFilterRollCall,
            setActiveFilterRollCall ,
            jsonParmsRollCall ,
            setJsonParmsRollCall
        }}>
            {props.children}
        </ContextRollCall.Provider>
    )
}